module.exports = __webpack_public_path__ + "static/media/logo6.f403adb7.png";